export const environment = {
  URL: 'https://qa-im.alpha.simadvisory.com/spriced/platform',
  SELF_SERVICE_API_BASE_URL: 'https://qa-im.alpha.simadvisory.com',
  SELF_SERVICE_CHAT_API_URL: 'https://dvm.alpha.simadvisory.com/spriced/platform/ppt-dashboard/generate',

  KAVERI_DASHBOARD_CONFIG_BASE_URL: 'https://dvm.alpha.simadvisory.com/spriced/platform',
  KEYCLOAK_URL: 'https://auth.alpha.simadvisory.com',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
  bearer_token: true,
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  // CLIENT_LOGO_SRC — image URL. If set (Use Case 2), shown alone in toolbar.
  // If both CLIENT_LOGO_SRC and CLIENT_LOGO_ICON are empty (Use Case 1), default SIM Advisory branding is used.
  CLIENT_LOGO_SRC: "",
  // CLIENT_LOGO_ICON — mat-icon name (alternative to image URL). Used with CLIENT_LOGO_TEXT.
  CLIENT_LOGO_ICON: "",
  CLIENT_LOGO_TEXT: "",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "SPRICED IM",
  // DEFAULT_COMPANY_LOGO — local SVG SIM Advisory logo; takes precedence over COMPANY_LOGO_SRC when set.
  DEFAULT_COMPANY_LOGO: "assets/default-company-logo.svg",
  // DEFAULT_MAKE_INDIA_LOGO — local SVG Make-in-India logo; takes precedence over SECONDARY_LOGO_SRC when set.
  DEFAULT_MAKE_INDIA_LOGO: "assets/default-make-in-India-logo.svg",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  // SECONDARY_LOGO_ENABLED — set "false" to hide the Make-in-India/secondary
  // logo without removing its src config. Omitted/"true" elsewhere = shown.
  SECONDARY_LOGO_ENABLED: "false",
  // HEADER_COLOR — optional top-toolbar background override. Leave EMPTY for the
  // default look (near-white builder toolbar / themed toolbar elsewhere); set a
  // colour only if this deployment wants a tinted header bar.
  HEADER_COLOR: '',
  SECONDARY_COLOR: '#3688df',
  SECONDARY_COLOR_2: '#3688df',
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "KAVERI LITE",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  // CHAT_ENABLED — set "false" to hide the floating chat-assistant
  // button on every screen. Omitted/"true" = shown.
  CHAT_ENABLED: "false",
  agentApiUrl: 'http://localhost:8081',
  THEME_NAME: 'default',
  USE_ALT_SIDENAV: false,
  THEME_OPTIONS_ENABLED: true,
  THEME_TOGGLE_ENABLED: true,

  // Published dashboards: show the "Available Views" rail (the viewer's other

  // published dashboards as preview cards on the right). Optional per project;

  // a dashboard can also override it via its design key `rail.enabled`.

  PUBLISHED_VIEWS_RAIL_ENABLED: false,
  ALT_COMPANY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/logos/sim-logo-white.png',
  // PROJECT_MODE — project-specific branch: hides the generic Visualization
  // Builder / builder-screens launcher from the sidenav (only the published
  // Dashboards list shows) and hides the Back to Builder / Share actions +
  // "DVM Dashboard" kicker on the published dashboard view.
  PROJECT_MODE: true,

  // LANDING_ROUTE — where '/' redirects to for THIS deployment. Leave empty for
  // the generic product (opens the Data Builder). For a project build that ships
  // dashboards instead of the builders, point it at that dashboard, e.g.
  //   LANDING_ROUTE: 'dvm-published/margin-estimator-spec-build-ai01',
  // A published Landing Page template (builder → "Landing page") works the same
  // way — point this at its /dvm-published/<slug> to make it the app's home.
  LANDING_ROUTE: '/dvm-published/my-landing-page-e8owzo',
};
